module.exports = __webpack_public_path__ + "img/service_icon3.f84d4473.png";